import { useEffect, useRef } from "react";
import { getPaymentStatusFromSisad } from "../redux/api/account";
import { sisadEstadoPagoEnum } from "../redux/types/payment";

const usePaymentWatchdog = (page, idClient, setPage, options = {}) => {

    const {
        paymentConfig = {
            'iframe': {
                pollingTime: 2000,
                maxAttempts: 200,
                shouldExit: (status) => status !== sisadEstadoPagoEnum.EN_PROCESO
            },
            'qrWalletPayment': {
                pollingTime: 2000,
                maxAttempts: 30,
                shouldExit: (status) => status === sisadEstadoPagoEnum.PAGADO,
                onSuccess: null
            }
        }
    } = options;

    const pollerAttemptsRef = useRef(0);

    useEffect(() => {
        // Solo activa si page tiene configuración
        const config = paymentConfig[page];
        if (!config || !idClient) return;

        pollerAttemptsRef.current = 0;

        const interval = setInterval(async () => {
            pollerAttemptsRef.current += 1;

            const req = await getPaymentStatusFromSisad(idClient);

            if (req.error) {
                clearInterval(interval);
                setPage(null);
                return;
            }

            // Si se cumple la condición de salida
            if (config.shouldExit(req.estadoPagoId)) {
                const isSuccessful = config.isSuccess ? config.isSuccess(req.estadoPagoId) : false;
                
                // Si fue exitoso y hay callback, ejecutar sin hacer setPage (asume que onSuccess lo hace)
                if (isSuccessful && config.onSuccess) {
                    config.onSuccess();
                } else {
                    // Si falló o no hay criterio de éxito, volver
                    setPage(null);
                }
                clearInterval(interval);
                return;
            }

            // Si se agotan los intentos
            if (pollerAttemptsRef.current >= config.maxAttempts) {
                clearInterval(interval);
                setPage(null);
            }
        }, config.pollingTime);

        return () => clearInterval(interval);
    }, [page, idClient, paymentConfig]);

};

export default usePaymentWatchdog;
